import { partial } from 'lodash/fp';
import { type } from '@mews/framework';
import ApiComponent from '../apiComponent';
import createRequest from './misc/createRequest';
import searchable from './traits/searchable';

const BASE_URL = '/bills';

export default function BillComponent(apiComponent: $TSFixMe) {
    type.check(apiComponent, ApiComponent);
    const request = createRequest(apiComponent.request, BASE_URL);

    return type.create(BillComponent, searchable(partial(request, ['/search'])));
}
